import { render } from "./Checkbox.vue?vue&type=template&id=874f4e5c"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=874f4e5c&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__